var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"c-button--icon-large c-button--icon-round",on:{"click":_vm.share}},[_c('Icon',{attrs:{"icon":_vm.iconShare,"size":24,"stroke":"black"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }